export const smoothScrollToHashMixin = {
  methods: {
    isHashUrl(url) {
      return typeof url === "string" && url.charAt(0) === "#" && url.length > 1;
    },
    smoothScrollToHash(url) {
      if (!this.isHashUrl(url)) return false;

      const id = url.slice(1);
      if (typeof window === "undefined" || typeof document === "undefined") {
        return false;
      }

      const el = document.getElementById(id);
      if (!el || !el.scrollIntoView) return false;

      try {
        // Read sticky navbar height from CSS var --cr-nav-height
        var root = document.documentElement;
        var styles = window.getComputedStyle(root);
        var navVar = styles.getPropertyValue("--cr-nav-height");
        var navHeight = 0;
        if (navVar) {
          // Expect values like "64px"; parseFloat will handle it
          var parsed = parseFloat(navVar);
          if (!isNaN(parsed)) {
            navHeight = parsed;
          }
        }

        // Compute target position with offset
        var rect = el.getBoundingClientRect();
        var absoluteY = rect.top + window.pageYOffset;
        var targetY = Math.max(absoluteY - navHeight, 0);

        window.scrollTo({ top: targetY, behavior: "smooth" });
        if (window && window.history && window.history.replaceState) {
          window.history.replaceState(null, "", url);
        }
        return true;
      } catch (e) {
        // Fallback just in case
        el.scrollIntoView();
        return true;
      }
    },
    handleSmoothScrollIfHash(url) {
      return this.smoothScrollToHash(url);
    },
  },
};
